<script>
  import { Button, Input } from "agnostic-svelte"
  import { Link } from "svelte-routing"
	import {store} from './store'
	
	let userd = store.userd;
	
</script>

<h1>Find your most affordable health plan</h1>
<div class="flex flex-column items-center container">
  <Input bind:value={userd.zip} placeholder="Zip code" />
  <Link to="/quote"><Button mode="primary">See Plans</Button></Link>
</div>
